import React from 'react';

const SelectField = ({ name, options, handleChange, label }) => {
	return (
		<div style={{ display: 'flex', flexDirection: 'column', marginBottom: '6px' }}>
			<label>{label}</label>
			<select name={name} onChange={handleChange}>
				{options.map((option, index) => (
					<option key={index} value={option}>{option}</option>
				))}
			</select>
		</div>
	);
}

export default SelectField;
